import { createAction, props } from '@ngrx/store';
import { Statistics } from '../../../models/statistics';

export const getStatistics = createAction('[Statistics] Get Statistics');

export const getStatisticsSuccess = createAction(
  '[Statistics] Get Statistics Success',
  props<{ statistics: Statistics }>()
);

export const getStatisticsError = createAction('[Statistics] Get Statistics Error');

export const getStatuses = createAction('[Statistics] Get Statuses');

export const getStatusApi = createAction('[Statistics] Get Status API');

export const getStatusApiSuccess = createAction('[Statistics] Get Status API Success');

export const getStatusApiError = createAction('[Statistics] Get Status API Error');

export const getStatusDashboard = createAction('[Statistics] Get Status Dashboard');

export const getStatusDashboardSuccess = createAction('[Statistics] Get Status Dashboard Success');

export const getStatusDashboardError = createAction('[Statistics] Get Status Dashboard Error');

export const getStatusAndroid = createAction('[Statistics] Get Status Android');

export const getStatusAndroidSuccess = createAction('[Statistics] Get Status Android Success');

export const getStatusAndroidError = createAction('[Statistics] Get Status Android Error');

export const getStatusApple = createAction('[Statistics] Get Status Apple');

export const getStatusAppleSuccess = createAction('[Statistics] Get Status Apple Success');

export const getStatusAppleError = createAction('[Statistics] Get Status Apple Error');
